module.exports = __webpack_public_path__ + "static/img/wanDaContent3.8bb7b6f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/wanDaContent3.png
// module id = TvCH
// module chunks = 2